import { render, staticRenderFns } from "./CardCustomerSearch.vue?vue&type=template&id=9a0f351a&"
import script from "./CardCustomerSearch.vue?vue&type=script&lang=js&"
export * from "./CardCustomerSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports